export default __webpack_public_path__ + "static/media/product4.76bd5d0c.JPG";